module.exports = __webpack_public_path__ + "img/14.68f9d7ec.jpg";